export default __webpack_public_path__ + "static/media/hbs-cbb-3.f6a9ea87.png";